import { PrinterPlatform, PrinterType } from '../enums';

export const DefaultPrinterTypeId = PrinterType.p95s;
export const DefaultPrinterPlatformId = PrinterPlatform.P95S;
